import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getBlogPath(tenant: Tenant): string {
	const pathMap = {
		[Locale.cs]: "/blog" as const,
	} satisfies LocalizedString;
	return getPathInLocale(tenant.locale, pathMap);
}
